import { type FC } from 'react';
import { AppShell, Box, Button, Group, Text } from '@mantine/core';
import { Link } from 'react-router';
import { useUnit } from 'effector-react';
import { IconWorld } from '@tabler/icons-react';
import { $authInfo } from '~/entities/auth';
import { $processingMode } from '~/entities/processing-mode';
import { routes } from '~/shared/constants/routes';
import { ThemeSwitcher } from '~/shared/ui/ThemeSwitcher';
import { useBreakpoint } from '~/shared/lib/hooks/useBreakpoint';
import { Balance, ProfileMenu, Rate } from './components';
import styles from './Header.module.css';

interface HeaderProps {
    variant?: 'app' | 'public';
}

const headerHeight = 'var(--header-height)';

export const Header: FC<HeaderProps> = ({ variant }) => {
    const {
        mode,
        authInfo: { isAuthenticated },
    } = useUnit({
        mode: $processingMode,
        authInfo: $authInfo,
    });

    const isMobile = useBreakpoint('mobile');

    const isPublic = variant === 'public';
    const showAuthActions = isPublic && !isAuthenticated;

    return (
        <AppShell.Header h={headerHeight}>
            <Box className={styles.header}>
                <Group
                    className={styles.brand}
                    gap='sm'
                    wrap='nowrap'
                >
                    <Link to={routes.app}>
                        <Group
                            align='center'
                            gap={4}
                            wrap='nowrap'
                        >
                            <IconWorld />

                            <Text
                                fz={24}
                                fw={700}
                            >
                                Unite
                            </Text>
                        </Group>
                    </Link>
                </Group>

                {isAuthenticated && (
                    <Box className={styles.balance}>
                        <Balance />
                    </Box>
                )}

                <Group
                    className={styles.actions}
                    gap='sm'
                    wrap='nowrap'
                >
                    {showAuthActions && (
                        <>
                            {!isMobile && (
                                <Button
                                    component={Link}
                                    to={routes.login}
                                    variant='subtle'
                                    size='sm'
                                >
                                    Войти
                                </Button>
                            )}

                            <Button
                                component={Link}
                                to={routes.registration}
                                size='sm'
                            >
                                Регистрация
                            </Button>
                        </>
                    )}

                    {mode === 'payout' && <Rate />}

                    {isAuthenticated && !isMobile && <ProfileMenu />}

                    <ThemeSwitcher />
                </Group>
            </Box>
        </AppShell.Header>
    );
};
